export const HC_IN_DELIVERY_TITLE = 'Get online before your engineer visit';
export const HC_IN_OPENREACH_APPT_TITLE = 'Get online now - before your engineer visit';
export const HC_IN_DELIVERY_DESCRIPTION =
  'As soon as your Smart Hub and Hybrid Connect’s delivered, you can set up and get up and running.';
export const HC_IN_OPENREACH_APPT_DESCRIPTION =
  'Why wait to get working? Your Smart Hub and Hybrid Connect’s delivered, so you can get connected.';
export const GET_ONLINE_LABEL = 'How to get online';
export const GET_ONLINE_SMART_HUB_2_URL = 'https://www.bt.com/business/getconnected';
export const GET_ONLINE_SMART_HUB_3_URL = 'https://www.bt.com/business/whywait';
export const ANALYTICS_TYPE_DELIVERY = 'royal mail delivery';
export const ANALYTICS_TYPE_APPOINTMENT = 'openreach engineer appointment';
